<template>
  <div id="contenedor-filtros-catalogo-avance-real">
    <v-card
      flat>
      <v-card-title>
        Buscar concepto
      </v-card-title>
      <v-card-text>
        <custom-text-field
          label="Buscar..."
          append-icon="mdi-magnify"
          clearable
          @keyup="buscar"
          @click:clear="limpiarBuscadorTexto">
        </custom-text-field>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import CustomTextField from '@/components/inputs/sinColumnas/TextField.vue';
import mixContratoAvanceReal from './mixContratoAvanceReal';

export default {
  name: 'FiltrosCatalogoAvanceReales',
  mixins: [mixContratoAvanceReal],
  props: {
    idContrato: {
      type: String,
      required: true,
    },
    filtros: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomTextField,
  },
  data() {
    return {};
  },
  methods: {
    buscar(e) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.filtros.buscarTexto = e.target.value;
      }, 600);
    },
    limpiarBuscadorTexto() {
      this.filtros.buscarTexto = '';
    },
  },
};
</script>

<style lang="scss">

</style>
